import * as Yup from "yup";
import { MAX_PAN_REQUIRED_AMOUNT } from "../../../_constants/constant";

export const useValidationSchema = ({
  ADULT,
  CHILD,
  INFANT,
  AdultRequireDetails,
  ChildRequireDetails,
  InfantRequireDetails,
  isGSTRequired,
  //   isGSTApplicable,
  totalAmount,
  billingData,
  travellerConfirm,
}: {
  ADULT: number;
  CHILD: number;
  INFANT: number;
  AdultRequireDetails: any;
  ChildRequireDetails: any;
  InfantRequireDetails: any;
  isGSTRequired: boolean;
  //   isGSTApplicable: boolean;
  totalAmount: number;
  billingData: any;
  travellerConfirm: boolean;
}) => {
  const travellerSchema = Yup.object().shape({
    initial: Yup.string().when("isSelected", {
      is: (isSelected: boolean) => isSelected,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    first_name: Yup.string().when("isSelected", {
      is: (isSelected: boolean) => isSelected,
      then: (schema) =>
        schema
          .matches(/^[A-Za-z\s]+$/, "Only alphabets are allowed")
          .min(2, "Must be at least 2 characters")
          .max(30, "Must be at most 30 characters")
          .required("First name is required"),
      otherwise: (schema) => schema.nullable(),
    }),
    last_name: Yup.string().when("isSelected", {
      is: (isSelected: boolean) => isSelected,
      then: (schema) =>
        schema
          .matches(/^[A-Za-z\s]+$/, "Only alphabets are allowed")
          .min(2, "Must be at least 2 characters")
          .max(30, "Must be at most 30 characters")
          .required("Last name is required"),
      otherwise: (schema) => schema.nullable(),
    }),
  });

  const adultSchema = Yup.object().shape({
    ...travellerSchema.fields,
    date_of_birth: Yup.string().when("isSelected", {
      is: (isSelected: boolean) => isSelected && AdultRequireDetails?.DOB,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    passport_no: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && AdultRequireDetails?.Passport_Number,
      then: (schema) =>
        schema
          .required("Required")
          .matches(/^[A-Z]{1}[0-9]{7}$/, "Invalid passport number"),
      otherwise: (schema) => schema.nullable(),
    }),
    expire_date: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && AdultRequireDetails?.Passport_Expiry,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    issue_country_code: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && AdultRequireDetails?.Passport_Issuing_Country,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    student_id: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && AdultRequireDetails?.Student_Id,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    defence_service_id: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && AdultRequireDetails?.DefenceServiceId,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    defence_issue_date: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && AdultRequireDetails?.DefenceIssueDate,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    defence_expiry_date: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && AdultRequireDetails?.DefenceExpiryDate,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
  });

  const childSchema = Yup.object().shape({
    ...travellerSchema.fields,
    date_of_birth: Yup.string().when("isSelected", {
      is: (isSelected: boolean) => isSelected && ChildRequireDetails?.DOB,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    passport_no: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && ChildRequireDetails?.Passport_Number,
      then: (schema) =>
        schema
          .required("Required")
          .matches(/^[A-Z]{1}[0-9]{7}$/, "Invalid passport number"),
      otherwise: (schema) => schema.nullable(),
    }),
    expire_date: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && ChildRequireDetails?.Passport_Expiry,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    issue_country_code: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && ChildRequireDetails?.Passport_Issuing_Country,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    student_id: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && ChildRequireDetails?.Student_Id,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    defence_service_id: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && ChildRequireDetails?.DefenceServiceId,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    defence_issue_date: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && ChildRequireDetails?.DefenceIssueDate,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    defence_expiry_date: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && ChildRequireDetails?.DefenceExpiryDate,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
  });

  const infantSchema = Yup.object().shape({
    ...travellerSchema.fields,
    date_of_birth: Yup.string().when("isSelected", {
      is: (isSelected: boolean) => isSelected && InfantRequireDetails?.DOB,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    passport_no: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && InfantRequireDetails?.Passport_Number,
      then: (schema) =>
        schema
          .required("Required")
          .matches(/^[A-Z]{1}[0-9]{7}$/, "Invalid passport number"),
      otherwise: (schema) => schema.nullable(),
    }),
    expire_date: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && InfantRequireDetails?.Passport_Expiry,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    issue_country_code: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && InfantRequireDetails?.Passport_Issuing_Country,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    student_id: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && InfantRequireDetails?.Student_Id,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    defence_service_id: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && InfantRequireDetails?.DefenceServiceId,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    defence_issue_date: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && InfantRequireDetails?.DefenceIssueDate,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    defence_expiry_date: Yup.string().when("isSelected", {
      is: (isSelected: boolean) =>
        isSelected && InfantRequireDetails?.DefenceExpiryDate,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
  });

  const validationSchema = Yup.object().shape({
    adults: Yup.array().when("ADULT", {
      is: () => ADULT > 0,
      then: (schema) => schema.of(adultSchema),
      otherwise: (schema) => schema.nullable(),
    }),
    children: Yup.array().when("CHILD", {
      is: () => CHILD > 0,
      then: (schema) => schema.of(childSchema),
      otherwise: (schema) => schema.nullable(),
    }),
    infants: Yup.array().when("INFANT", {
      is: () => INFANT > 0,
      then: (schema) => schema.of(infantSchema),
      otherwise: (schema) => schema.nullable(),
    }),
    email_id: Yup.string()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email"
      )
      .required("Email is required"),
    mobile_no: Yup.string()
      .matches(/^[0-9]{10}$/, "Invalid mobile number")
      .required("Mobile number is required"),
    gst_number: Yup.string().when("isGST", {
      is: (isGST: boolean) => isGST || isGSTRequired,
      then: (schema) =>
        schema
          .matches(
            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
            "Invalid GST number"
          )
          .required("GST number is required"),
      otherwise: (schema) => schema.nullable(),
    }),
    gst_registered_name: Yup.string().when("isGST", {
      is: (isGST: boolean) => isGST || isGSTRequired,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    gst_address: Yup.string().when("isGST", {
      is: (isGST: boolean) => isGST || isGSTRequired,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    state_id: Yup.string().when("isGST", {
      is: (isGST: boolean) => isGST || isGSTRequired,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    billing_pan_card_no: Yup.string().when("isGST", {
      is: (isGST: boolean) =>
        totalAmount > MAX_PAN_REQUIRED_AMOUNT &&
        !billingData?.billing_pan_card_no &&
        travellerConfirm,
      then: (schema) =>
        schema
          .required("PAN is required")
          .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN format"),
      otherwise: (schema) => schema.nullable(),
    }),
  });

  return { validationSchema };
};
